module.exports = __webpack_public_path__ + "img/logo-gray-cut.8bd6210b.png";